// src/components/shared/Header.jsx
import React from 'react';
import { styles } from '../../styles/theme';
import { PROGRAM_INFO } from '../../utils/constants';
import Button from './Button';

/**
 * Reusable Header Component
 */
export const Header = ({ 
  title, 
  subtitle, 
  onBack, 
  actions,
  showLogo = false,
  showProgramInfo = false 
}) => {
  return (
    <div style={styles.header}>
      <div style={styles.centerContainer}>
        {onBack && (
          <Button 
            variant="outline" 
            onClick={onBack}
            style={{ marginBottom: '1rem' }}
          >
            ← Back
          </Button>
        )}
        
        {showLogo || showProgramInfo ? (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              {showLogo && (
                <img 
                  src="/images/logo.png" 
                  alt="Stemtree" 
                  style={{ height: '45px', flexShrink: 0 }} 
                />
              )}
              <div>
                <h1 style={styles.headerTitle}>
                  {title || PROGRAM_INFO.name}
                </h1>
                {(subtitle || showProgramInfo) && (
                  <p style={styles.headerSubtitle}>
                    {subtitle || `${PROGRAM_INFO.address} • ${PROGRAM_INFO.phone}`}
                  </p>
                )}
              </div>
            </div>
            {actions && <div>{actions}</div>}
          </div>
        ) : (
          <div style={styles.flexBetween}>
            <div>
              <h1 style={styles.headerTitle}>{title}</h1>
              {subtitle && <p style={styles.headerSubtitle}>{subtitle}</p>}
            </div>
            {actions && <div>{actions}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Public Header (for registration pages)
 */
export const PublicHeader = () => {
  return (
    <div style={{ 
      background: 'white',
      borderBottom: '1px solid #e5e7eb',
      padding: '1.5rem 0'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '0 1rem', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '1rem' 
      }}>
        <img 
          src="/images/logo.png" 
          alt="Stemtree" 
          style={{ 
            height: 'clamp(40px, 10vw, 60px)', 
            flexShrink: 0 
          }} 
        />
        <div style={{ minWidth: 0 }}>
          <h1 style={{ 
            margin: 0, 
            fontSize: 'clamp(1rem, 4vw, 1.75rem)', 
            fontWeight: 'bold', 
            color: '#111827' 
          }}>
            {PROGRAM_INFO.name}
          </h1>
          <p style={{ 
            margin: '0.25rem 0 0 0', 
            color: '#6b7280', 
            fontSize: 'clamp(0.65rem, 2.5vw, 0.875rem)',
            lineHeight: '1.3'
          }}>
            {PROGRAM_INFO.address} • {PROGRAM_INFO.phone}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;